import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BaseService } from '@appService/base.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})

export class NotifyService extends BaseService {

    contextPath = this.contextPathNotify + '/notify'

    constructor(
      http: HttpClient,
        private http_: HttpClient,
    ) {
      super(http)
    }

    searchApi(body: any, Parameters:any): Observable<any[]> {
      return this.post(this.contextPath + '/searchByStaff', body, Parameters)
    }

    updateReadNotify(body: any): Observable<any[]> {
      return this.post(this.contextPath + '/updateReadNotify', body)
    }

    updatereadall(body: any): Observable<any[]> {
      return this.post(this.contextPath + '/update-read-all', body)
    }

    filterByStaff(Parameters:any): Observable<any[]> {
      return this.post(this.contextPath + '/filterByStaff', '', Parameters)
    }

}
